import React, { Fragment, useState, useEffect, useContext } from "react";
import ReactEcharts from "echarts-for-react";
import { getBookingAcceptedData } from "../../../Services/DispatchDashboard.service";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import CustomizerContext from "../../../_helper/Customizer";

const BookingsAccepted = ({ globalCityField }) => {
  const [bookingsAcceptedList, setBookingsAcceptedList] = useState([]);
  const [loader, setLoader] = useState(false)

  const [options, setOptions] = useState();
  const { mix_background_layout } =
        useContext(CustomizerContext);

  const calculatePercent = (num, den) => {
    return ((num / den) * 100).toFixed(2);
  };

  useEffect(() => {
    setLoader(true)
    const serviceCityId = globalCityField?.value?.id || null;
    let obj = {
      serviceCityId: serviceCityId,
    };

    getBookingAcceptedData(obj).then((result) => {
      console.log(result, "dispatch count data");
      setLoader(false)
      if (result.data) {
        setBookingsAcceptedList(result.data);
      }
    });
  }, []);
  useEffect(() => {
    if (bookingsAcceptedList.length == 0) return;
    const serviceCityId = globalCityField.value?.id;
    let totalTrips = 0;
    const dataObj = {};
    if (!serviceCityId) {
      bookingsAcceptedList.forEach((element) => {
        totalTrips += Number(element.Count);
        if (!(element.BookingViaType in dataObj)) {
          dataObj[element.BookingViaType] = 0;
        }
        dataObj[element.BookingViaType] += Number(element.Count);
      });
    } else {
      bookingsAcceptedList.forEach((element) => {
        if (element.ServiceCityId != serviceCityId) return;
        totalTrips += Number(element.Count);
        if (!(element.BookingViaType in dataObj)) {
          dataObj[element.BookingViaType] = 0;
        }
        dataObj[element.BookingViaType] += Number(element.Count);
      });
    }

    const graphData = [];

    for (let key in dataObj) {
      graphData.push({
        value: calculatePercent(dataObj[key], totalTrips),
        name: key,
      });
    }

    console.log(graphData, "graphdata");
    setOptions({
      backgroundColor: "rgba(255, 0, 0, 0)",
      tooltip: {
        trigger: "item",
      },
      title: {
        text: `Bookings\nAccepted`,
        left: "center",
        top: "center",
        textStyle: {
          color: mix_background_layout == "dark-only" ? "rgba(255, 255, 255, 0.7)" : "black"
        }
      },
      series: [
        {
          name: "Bookings Accepted",
          type: "pie",
          radius: ["40%", "70%"],
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2,
            normal: {
              label: {
                show: true,
                position: "outer",
                formatter: function (params) {
                  return params.value + "%\n" + params.name;
                },
              },
              labelLine: {
                show: true,
              },
            },
          },
          data: graphData,
        },
      ],
    });
  }, [bookingsAcceptedList, globalCityField.value,mix_background_layout]);

  return (
    <Fragment>
      {loader ? <Skeleton width={"100%"} height={"80%"} />
        :
        options ? (
          <ReactEcharts option={options} theme={mix_background_layout == "dark-only" ? "dark" : ""}/>
        ) : (
          <div className="no-data-available">
            <span>No Data Available</span>
          </div>
        )}
    </Fragment>
  );
};

export default BookingsAccepted;
